<template>
  <div class="c-base-form-group">
    <div :class="[labelColsSm ? 'grid grid-cols-12 sm:gap-x-4' : '']">
      <div class="pb-2" :class="[labelColsSm ? `col-span-12 sm:col-span-${labelColsSm} sm:pt-2` : '']" v-if="hasSlots('label') || label">
        <slot name="label">
          <label class="w-full text-base" :for="labelForAsKebabCase" tabindex="-1">{{ label }}</label>
        </slot>
      </div>
      <div :class="[labelColsSm ? `col-span-12 sm:col-span-${(12 - labelColsSm || 12)}` : '']">
        <slot />
        <div v-if="description" class="mt-1 text-xs text-dark-grey-400">
          {{ description }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { kebabCase } from 'lodash'

export default {
  name: 'BaseFormGroup',

  props: {
    description: {
      type: String,
      required: false
    },
    label: {
      type: String,
      required: false
    },
    labelFor: {
      type: String,
      required: false
    },
    labelColsSm: {
      type: [Number, String],
      required: false
    }
  },

  computed: {
    labelForAsKebabCase () {
      return kebabCase(this.labelFor)
    }
  },

  methods: {
    hasSlots (name) {
      return this.$scopedSlots[name] && (this.$scopedSlots[name]() || []).some(item => !item.isComment)
    }
  }
}
</script>
